var _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThemeParkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#6304FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 51,
    height: 51,
    rx: 25.5,
    fill: "#8E64FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 51,
    height: 51,
    rx: 25.5,
    stroke: "white",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_664_12642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 29V39",
    stroke: "#000204",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 26L35.5 40.5",
    stroke: "#000204",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 26L18.5 40.5",
    stroke: "#000204",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 26,
    r: 9,
    fill: "#FF3A74"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 26,
    r: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 26,
    r: 5,
    fill: "#FF3A74"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 26,
    r: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 26L19.5 18.5",
    stroke: "#000204",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0015 14.9987L19.0013 17.9987L16 18L19.0015 21L22 21L22 18L19.0015 14.9987Z",
    fill: "#FFFF6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_664_12642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeParkIcon);
export default __webpack_public_path__ + "static/media/theme-park-icon.ae6c3776cec7681486c3b95db6d6a130.svg";
export { ForwardRef as ReactComponent };